// Shrink

function shrink() {

    // console.log('shrink component loaded');

    const offset = 150;
    const body = document.body;
    const header = document.querySelector('.site__header');

    /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
    let prevScrollpos = window.pageYOffset;

    function handleScroll() {
        if (window.scrollY > offset) {
            body.classList.add('shrink');
        } else {
            body.classList.remove('shrink');
        }

        if (!header) {
            return;
        }

        const currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            header.classList.remove('hide-menu');
        } else {
            header.classList.add('hide-menu');
        }
        prevScrollpos = currentScrollPos;
    }

    window.addEventListener('scroll', handleScroll);
    
}

export default shrink;